import { PanelColorSettings } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

export default function ColorsControls( { attributes, setAttributes } ) {
	const handleChangeNavigation = ( key, value ) => {
		setAttributes( {
			navigation: {
				...attributes.navigation,
				[ key ]: value,
			},
		} );
	};

	const handleChangePagination = ( key, value ) => {
		setAttributes( {
			pagination: {
				...attributes.pagination,
				[ key ]: value,
			},
		} );
	};

	return (
		<PanelColorSettings
			title={ __( 'Colors', 'brandy-blocks' ) }
			initialOpen={ false }
			enableAlpha={ true }
			colorSettings={ [
				...( attributes.navigation?.enabled ?? true
					? [
							{
								value: attributes.navigation?.iconColor,
								onChange: ( v ) =>
									handleChangeNavigation( 'iconColor', v ),
								clearable: true,
								label: __(
									'Navigation arrow',
									'brandy-blocks'
								),
							},
							{
								value: attributes.navigation
									?.iconHoverColor,
								onChange: ( v ) =>
									handleChangeNavigation(
										'iconHoverColor',
										v
									),
								clearable: true,
								label: __(
									'Navigation arrow hover',
									'brandy-blocks'
								),
							},
							{
								value: attributes.navigation
									?.backgroundColor,
								onChange: ( v ) =>
									handleChangeNavigation(
										'backgroundColor',
										v
									),
								clearable: true,
								label: __(
									'Navigation button',
									'brandy-blocks'
								),
							},
							{
								value: attributes.navigation
									?.backgroundHoverColor,
								onChange: ( v ) =>
									handleChangeNavigation(
										'backgroundHoverColor',
										v
									),
								clearable: true,
								label: __(
									'Navigation button hover',
									'brandy-blocks'
								),
							},
					  ]
					: [] ),
				...( attributes.pagination?.enabled ?? true
					? [
							{
								value: attributes.pagination?.defaultColor,
								onChange: ( v ) =>
									handleChangePagination(
										'defaultColor',
										v
									),
								clearable: true,
								label: __(
									'Pagination dot',
									'brandy-blocks'
								),
							},
							{
								value: attributes.pagination?.activeColor,
								onChange: ( v ) =>
									handleChangePagination(
										'activeColor',
										v
									),
								clearable: true,
								label: __(
									'Pagination dot active',
									'brandy-blocks'
								),
							},
					  ]
					: [] ),
			] }
		/>
	);
}
